import {adicRestApi, adicRestApiAdUrl, adicRestApiMypageUrl} from '../index';

export const getAdCategoryList = async (reqBody = {}) => {
  if (!reqBody) return {};
  const url = adicRestApiAdUrl
    .segment("/category/list")
    .toString();

  const { data } = await adicRestApi.post(url, reqBody);
  return data;
};

export const getAdTvRecentList = async (adId, adUrl) => {
  const url = adicRestApiAdUrl
    .segment("/tv/recent-list")
    .param(adId)
    .query(adUrl)
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};

export const getAdDetailView = async (category, ukey) => {
  const url = adicRestApiAdUrl
    .segment("/:category/info")
    .param({
      category,
    })
    .query({ukey})
    .toString();
  const { data } = await adicRestApi.get(url);
  return data;
};

export const getAdLikeStatus = async (category, ukey) => {
  const url = adicRestApiAdUrl
    .segment("/:category/like")
    .param({ category })
    .query({ ukey })
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};

export const postAdLikeStatus = async (category, ukey) => {
  const url = adicRestApiAdUrl
    .segment(`/:category/like`)
    .param({ category })
    .query({ ukey })
    .toString();

  const { data } = await adicRestApi.post(url, { test: "data" });
  return data;
};


export const removeAdLikeStatus = async (category, ukey) => {
  const url = adicRestApiAdUrl
    .segment(`/:category/like`)
    .param({ category })
    .query({ ukey })
    .toString();

  const { data } = await adicRestApi.delete(url);
  return data;
};
